import { useCallback } from 'react'
import { useAuthenticationState } from '~/atoms/AuthenticationState'
import { useSettingsState } from '~/atoms/SettingsState'
import { useUserState } from '~/atoms/UserState'
import useElectronIPC from '~/hooks/useElectronIPC'
import {
  useQueueLogout,
  useUpdateUserAgentStatus,
} from '~/queries/queueQueries'

export const useLogout = () => {
  const { currentUserExtensionId, currentUserExtension } = useUserState()
  const {
    settings: {
      callCenter: { isEnabled: callCenterEnabled },
    },
  } = useSettingsState()
  const { logout } = useAuthenticationState()
  const updateUserAgentStatus = useUpdateUserAgentStatus({})
  const queueLogout = useQueueLogout({
    extensionId: currentUserExtensionId,
  })
  const { updateMenus } = useElectronIPC()

  return useCallback(async () => {
    try {
      if (currentUserExtensionId && callCenterEnabled) {
        await queueLogout()
        await updateUserAgentStatus(null, currentUserExtension?.uuid, false)
      }

      updateMenus({ enableAuthedMenuItems: false })
    } catch (error) {
      console.warn('Error during logout cleanup:', error)
    } finally {
      logout()
    }
  }, [
    currentUserExtensionId,
    currentUserExtension?.uuid,
    queueLogout,
    updateUserAgentStatus,
    logout,
    callCenterEnabled,
  ])
}
